(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disc-ibq', {
            parent: 'entity',
            url: '/disc-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.disc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disc/discsibq.html',
                    controller: 'DiscIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disc-ibq-detail', {
            parent: 'disc-ibq',
            url: '/disc-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.disc.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disc/disc-ibq-detail.html',
                    controller: 'DiscIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disc');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Disc', function($stateParams, Disc) {
                    return Disc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'disc-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('disc-ibq-detail.edit', {
            parent: 'disc-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-dialog.html',
                    controller: 'DiscIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disc', function(Disc) {
                            return Disc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disc-ibq.new', {
            parent: 'disc-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-dialog.html',
                    controller: 'DiscIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                paralelTitle: null,
                                serieNumber: null,
                                content: null,
                                productionYear: null,
                                coverFile: null,
                                coverFileContentType: null,
                                coverPath: null,
                                producer: null,
                                interpreter: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disc-ibq', null, { reload: 'disc-ibq' });
                }, function() {
                    $state.go('disc-ibq');
                });
            }]
        })
        .state('disc-ibq.edit', {
            parent: 'disc-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-dialog.html',
                    controller: 'DiscIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disc', function(Disc) {
                            return Disc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disc-ibq', null, { reload: 'disc-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disc-ibq.delete', {
            parent: 'disc-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-delete-dialog.html',
                    controller: 'DiscIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Disc', function(Disc) {
                            return Disc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disc-ibq', null, { reload: 'disc-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
